import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ChapterApiService} from '../api/chapter-api.service';
import {ToastrService} from 'ngx-toastr';
import {CommitteeDTO, CommitteeService} from '../api/committee-api.service';
import {UserApiService} from '../api/user-api.service';
import {API_URL, BOT_ROLES, COMMITTEE_ROLES} from '../constants';
import {SharedService} from '../api/shared-service';
import {SpinnerService} from '../shared/services/spinner.service';
import {finalize, forkJoin} from 'rxjs';
import {RoleScope, reachesAllChapters, reachesChapter, storedRoleScope} from '../shared/access';

@Component({
  selector: 'app-create-bot',
  templateUrl: './create-bot.component.html',
  styleUrl: './create-bot.component.css'
})
export class CreateBotComponent  {
  showCommittee = true;
  chapterId!: string;

  memberForm: FormGroup;
  chapterUsers: any[] = [];
  chapter: any;
  chapterCreationError = false;
  committeeMembers: any;
  uploadedImageUrl: string | null = null;

  committees: CommitteeDTO[] = [];
  selectedCommittee?: CommitteeDTO;
  committeId: any;
  selectedMember: any;
  userRole: any;
  userGroup: any;
    roleScope: RoleScope = storedRoleScope();

    /** True for roles whose reach is every chapter (system administrator and the NEC tier), as decided by the API. */
    get allChapters(): boolean {
        return reachesAllChapters(this.roleScope);
    }
  userChapter: any;
  commiteeroles = BOT_ROLES;
  showUserDropdown = false;
  filteredUsers: any[] = [];
  chapterList: any[] = [];
  constructor(private route: ActivatedRoute,
              private sharedService: SharedService,
              private fb: FormBuilder,
              private toastr: ToastrService,
              private chapterApiService: ChapterApiService,
              private committeeService: CommitteeService,
              private usereApiService: UserApiService,
              private router: Router,
              private spinner: SpinnerService
  ) {

    this.memberForm = this.fb.group({
      role: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]

    });


    this.chapterId = this.route.snapshot.paramMap.get('id')!;
    this.userChapter = sessionStorage.getItem('chapter');

    this.sharedService.userRole$.subscribe((role) => {
      if (typeof role === 'string') {
        this.userRole = JSON.parse(role || '{}');
      } else {
        this.userRole = role;
      }
    });

    this.chapterApiService.getData().pipe(
        finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
    ).subscribe(
        (response) => {
          this.chapterList = response;
          // Filter out the chapter with id = 0 from the main list
          this.chapterList = response.filter((chapter: any) => chapter.id !== "0");
        },
        (error) => {
          console.error('Failed to load chapters', error);
        }
    );
  }

  ngOnInit(): void {
    this.spinner.show(); // Show spinner while loading chapters
    this.chapterId = this.route.snapshot.paramMap.get('id')!;
    this.userChapter = sessionStorage.getItem('chapter');

    this.userRole = JSON.parse(sessionStorage.getItem('rolesPermission') || '{}');

    this.userGroup = sessionStorage.getItem('userGroup') || '{}';
    this.roleScope = storedRoleScope();
    // or subscribe for dynamic updates
    this.route.paramMap.subscribe(params => {
      this.chapterId = params.get('id')!;

      this.chapterApiService.getChapterData(this.chapterId).subscribe({
        next: (response) => {
          this.chapter = response;
          this.viewCommitteesByChapterId(this.chapter.id);
        },
        error: (err) => {
          // Handle login error (invalid credentials, server error, etc.)
          console.error('Failed to load chapters', err);

        }
      });

      this.chapterApiService.getData().pipe(
          finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
      ).subscribe(
          (response) => {
            this.chapterList = response;
            // Filter out the chapter with id = 0 from the main list
            this.chapterList = response.filter((chapter: any) => chapter.id !== "0");
          },
          (error) => {
            console.error('Failed to load chapters', error);
          }
      );



    });

    this.usereApiService.getUsers().pipe(
        finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
    ).subscribe({

      next: (response) => {
        this.chapterUsers = response;

      },
      error: (err) => {
        // Handle login error (invalid credentials, server error, etc.)
        console.error('Failed to load chapter users', err);

      }
    });

    this.viewCommitteesByChapterId(this.chapterId);
    //console.log(this.committees);
  }

  get sortedCommitteeMembers() {
    return this.committeeMembers?.slice().sort((a: any, b: any) => {
      const aIndex = this.commiteeroles.findIndex(r => r.role === a.title);
      const bIndex = this.commiteeroles.findIndex(r => r.role === b.title);
      return aIndex - bIndex;
    }) || [];
  }

  editCommittee() {
    this.showCommittee = !this.showCommittee;
  }

  addCommitteeMember() {

    this.memberForm.patchValue({
      email: '',
      role: ''
    });
  }


  /*viewCommitteesByChapterId(chapterId: string): void {
    this.spinner.show(); // Show spinner while loading committees
    this.committeeService.getCommitteesByChapterId(chapterId).pipe(
        finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
    ).subscribe({
      next: (data) => {

        // 🔹 Create a lookup set of valid roles
        const validRoles = new Set(
            this.commiteeroles.map(r => r.role)
        );

        // 🔹 Filter out members whose title is NOT in BOT_ROLES
        this.committeeMembers = data.filter(member =>
            validRoles.has(member.title)
        );

        //this.committeeMembers = data;
        for (let i = 0; i < this.committeeMembers.length; i++) {

          const photouri = this.committeeMembers[i].photouri;
          if (photouri && photouri.trim() !== '' && photouri !== 'null') {
            const imageUrl = `${API_URL}profile/viewimage/${this.committeeMembers[i].userId}/${this.committeeMembers[i].photouri}`;

            this.usereApiService.getProfileImageAsBlob(imageUrl).subscribe(
                (blob: Blob) => {
                  if (blob && blob.size > 0) {
                    if (this.uploadedImageUrl) {
                      URL.revokeObjectURL(this.uploadedImageUrl);
                    }
                    this.committeeMembers[i].uploadedImageUrl = URL.createObjectURL(blob); // use in <img [src]>
                  } else {
                    console.error('Blob is empty or invalid.');
                  }
                },
                (error) => {
                  console.error('Failed to load image preview:', error);
                }
            );
          } else {
            // No photouri; skip API call
            this.committeeMembers[i].uploadedImageUrl = null; // optional: clear previous image
          }
        }
      },
      error: (err) => {
        console.error('Error fetching committee:', err);
      },
    });


  }
*/

  viewCommitteesByChapterId(chapterId: string): void {
    this.spinner.show();
if(chapterId !== undefined && chapterId == '0') {
  forkJoin({
    chapterCommittees: this.committeeService.getCommitteesByChapterId(chapterId),
    botChairs: this.committeeService.getAllBOTChairs()
  })
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe({
        next: ({ chapterCommittees, botChairs }) => {

          // 🔹 Build chapter lookup map
          const chapterMap = new Map(
              this.chapterList.map((c: any) => [c.id, c.name])
          );

          // 🔹 Enrich BOT Chairs
          const enrichedBotChairs = botChairs.map(botChair => {
            const chapterName = chapterMap.get(botChair.chapterId);
            return {
              ...botChair,
              title: chapterName ? `${botChair.title} (${chapterName})` : botChair.title
            };
          });

          // 🔹 Combine all committees
          const combined: CommitteeMemberView[] = [
            ...chapterCommittees,
            ...enrichedBotChairs
          ];

          // 🔹 Filter only valid roles
          const validRoles = new Set(this.commiteeroles.map(r => r.role));
          const filteredMembers = combined.filter(
              member => validRoles.has(member.title.split(' (')[0])
          );

          // 🔹 Custom role priority
          const rolePriority: { [key: string]: number } = {
            'Ex President': 1,
            'BOT Chair': 2
          };

          // 🔹 Sort: Ex President first, then BOT, then rest
          this.committeeMembers = filteredMembers.sort((a, b) => {
            const aBase = a.title.split(' (')[0];
            const bBase = b.title.split(' (')[0];

            const aPriority = rolePriority[aBase] ?? 99;
            const bPriority = rolePriority[bBase] ?? 99;

            // tie-break: alphabetical
            return aPriority - bPriority || aBase.localeCompare(bBase);
          });

          // 🔹 Load images after sorting
          this.committeeMembers.forEach((member: CommitteeMemberView) => {
            const photouri = member.photouri;
            if (photouri && photouri.trim() !== '' && photouri !== 'null') {
              const imageUrl = `${API_URL}profile/viewimage/${member.userId}/${photouri}`;
              this.usereApiService.getProfileImageAsBlob(imageUrl).subscribe(blob => {
                if (blob && blob.size > 0) {
                  if (member.uploadedImageUrl) URL.revokeObjectURL(member.uploadedImageUrl);
                  member.uploadedImageUrl = URL.createObjectURL(blob);
                }
              }, err => console.error(err));
            } else {
              member.uploadedImageUrl = null;
            }
          });
        },
        error: err => console.error(err)
      });

}else{
  this.committeeService.getCommitteesByChapterId(chapterId).pipe(
      finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
  ).subscribe({
    next: (data) => {

      // 🔹 Create a lookup set of valid roles
      const validRoles = new Set(
          this.commiteeroles.map(r => r.role)
      );

      // 🔹 Filter out members whose title is NOT in BOT_ROLES
      this.committeeMembers = data.filter(member =>
          validRoles.has(member.title)
      );

      //this.committeeMembers = data;
      for (let i = 0; i < this.committeeMembers.length; i++) {

        const photouri = this.committeeMembers[i].photouri;
        if (photouri && photouri.trim() !== '') {
          const imageUrl = `${API_URL}profile/viewimage/${this.committeeMembers[i].userId}/${this.committeeMembers[i].photouri}`;

          this.usereApiService.getProfileImageAsBlob(imageUrl).subscribe(
              (blob: Blob) => {
                if (blob && blob.size > 0) {
                  if (this.uploadedImageUrl) {
                    URL.revokeObjectURL(this.uploadedImageUrl);
                  }
                  this.committeeMembers[i].uploadedImageUrl = URL.createObjectURL(blob); // use in <img [src]>
                } else {
                  console.error('Blob is empty or invalid.');
                }
              },
              (error) => {
                console.error('Failed to load image preview:', error);
              }
          );
        } else {
          // No photouri; skip API call
          this.committeeMembers[i].uploadedImageUrl = null; // optional: clear previous image
        }
      }
    },
    error: (err) => {
      console.error('Error fetching committee:', err);
    },
  });
}
  }

  onEmailInput() {
    const input = this.memberForm.get('email')?.value?.toLowerCase() || '';
    this.filteredUsers = this.chapterUsers.filter(user =>
        (user.firstname + ' ' + user.lastname + ' ' + user.email).toLowerCase().includes(input)
    );
    this.showUserDropdown = !!input && this.filteredUsers.length > 0;
  }

  selectUser(user: any) {
    this.memberForm.patchValue({email: user.email});
    this.showUserDropdown = false;
  }

  hideDropdownWithDelay() {
    setTimeout(() => this.showUserDropdown = false, 200); // Delay to allow click
  }

  addCommittee(): void {

    if (this.memberForm.valid) {
      this.spinner.show(); // ✅ Show spinner before API call
      const memberData = this.memberForm.value;
      this.usereApiService.getUserByEmail(memberData).pipe(
          finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
      ).subscribe(
          (response) => {
            console.log('valid email', response);

            this.selectedCommittee = {
              title: memberData.role,
              chapterId: this.chapterId,
              userId: response.id
            };
            if (this.selectedCommittee) {
              this.committeeService.createCommittee(this.selectedCommittee).subscribe({
                next: (data) => {
                  console.log('Committee created:', data);
                  this.viewCommitteesByChapterId(this.chapterId); // Reload the list
                  this.toastr.success("Successfully added " + response.firstname + ' ' + response.lastname + ' as new ' + this.selectedCommittee?.title + ' in the committee.', 'Success');
                },
                error: (err) => {
                  console.error('Error creating committee:', err);
                  this.toastr.error('Failed to create committee', 'Submission Failed');
                },
              });


            }
            this.chapterCreationError = false;


          },
          (error) => {
            console.error('Failed to create chapter', error);
            this.chapterCreationError = true;
            this.toastr.error('Chapter failed to create.', 'Submission Failed');
          }
      );
    } else {
      this.toastr.error('Please fix the errors in the form.', 'Submission Failed');
    }
  }


  openEditModal(id: any, email: any, title: any): void {
    // Populate the form with the selected member's data
    this.committeId = id;
    this.memberForm.patchValue({
      email: email,
      role: title
    });
    // Open the modal
    const modal = document.getElementById('editBOTModal');
    if (modal) {
      modal.classList.add('show');
      modal.style.display = 'block';
    }
  }

  closeModal(): void {
    const modal = document.getElementById('editBOTModal');
    if (modal) {
      modal.classList.remove('show');
      modal.style.display = 'none';
    }
  }

  updateCommittee(): void {

    if (this.memberForm.valid) {
      this.spinner.show(); // ✅ Show spinner before API call
      const memberData = this.memberForm.value;
      this.usereApiService.getUserByEmail(memberData).pipe(
          finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
      ).subscribe(
          (response) => {
            console.log('valid email', response);

            this.selectedCommittee = {
              title: memberData.role,
              chapterId: this.chapterId,
              userId: response.id
            };
            if (this.selectedCommittee) {
              this.committeeService.updateCommittee(this.committeId, this.selectedCommittee).subscribe({
                next: (data) => {
                  console.log('Committee updated:', data);
                  this.viewCommitteesByChapterId(this.chapterId); // Reload the list
                  this.toastr.success("Successfully updated " + response.firstname + ' ' + response.lastname + ' as new ' + this.selectedCommittee?.title + ' in the committee.', 'Success');
                },
                error: (err) => {
                  console.error('Error creating committee:', err);
                  this.toastr.error('Failed to update committee', 'Submission Failed');
                },
              });


            }
            this.chapterCreationError = false;


          },
          (error) => {
            console.error('Failed to create chapter', error);
            this.chapterCreationError = true;
            this.toastr.error('Chapter failed to create.', 'Submission Failed');
          }
      );
    } else {
      this.toastr.error('Please fix the errors in the form.', 'Submission Failed');
    }


  }


  deleteCommittee(id: string): void {
    this.spinner.show(); // Show spinner while deleting committee
    this.committeeService.deleteCommittee(id).pipe(
        finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
    ).subscribe({
      next: () => {
        console.log('Committee deleted');
        this.viewCommitteesByChapterId(this.chapterId); // Reload the list
        this.toastr.success('Committee role removed', 'Success');
      },
      error: (err) => {
        console.error('Error deleting committee:', err);
      },
    });
  }

  // BOT Chair gets the solid accent role pill; everyone else (BOT Member, BOT Youth, Ex-President) gets the soft neutral one.
  isLeadershipRole(title: string | undefined): boolean {
    return title === 'BOT Chair';
  }

  memberInitials(member: any): string {
    const first = (member?.firstname || '').charAt(0);
    const last = (member?.lastname || '').charAt(0);
    return (first + last).toUpperCase() || '?';
  }

  // Deterministic per-member tint (same member always gets the same color), cycling
  // through the same tinted-avatar palette used in the member directory tables.
  private readonly avatarTints = ['accent', 'info', 'success'];
  avatarTint(member: any, index: number): string {
    return this.avatarTints[index % this.avatarTints.length];
  }

}

interface CommitteeMemberView extends CommitteeDTO {
  photouri?: string | null;
  uploadedImageUrl?: string | null;
  firstname?: string;
  lastname?: string;
  phone?: string;
  email?: string;
}